export default "__VITE_ASSET__9831938f__"